import { CloudDownload, Visibility, VisibilityOff } from '@mui/icons-material'
import {
	Box,
	Divider,
	Fade,
	IconButton,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useCallback, useEffect, useState } from 'react'
import { PortalVersion } from '../../../../../api/DTOtemp'
import { PortalsClient } from '../../../../../api/clients/identity/PortalsClient'
import { AssignmentType } from '../../../../../api/clients/workflowTasks/DTOs'
import { ClickToCopyButton } from '../../../../../components/buttons/ClickToCopyButton'
import UserChip from '../../../../../components/chips/UserChip'
import { downloadFile } from '../../../../../utils/DownloadFile'
import AdministrationPageContainer from '../../AdministrationPageContainer'
import { AdministrationPageTabs } from '../../AdministrationPageTabs'
import { usePortalContext } from './PortalPageContext'

export const PortalVersionsPage = () => {
	const context = usePortalContext()
	const styles = useStyles()
	const [versions, setVersions] = useState<PortalVersion[]>([])

	useEffect(() => {
		const portalsClient = new PortalsClient()

		portalsClient
			.GetPortalVersions(context.portal.id)
			.then((response) => {
				setVersions(response.data)
			})
			.catch((e) => {
				console.error(e)
			})
	}, [context.version, context.portal])

	const getLink = useCallback((versionNumber: number) => {
		let portalLink = `${window.location.origin}${!context.portal.authenticationRequired ? '/_external' : ''
			}/_portals/${context.portal.id}`

		if (versionNumber !== undefined) portalLink += `/_versions/${versionNumber}`

		return portalLink
	}, [])

	const downloadVersion = useCallback(async (versionNumber: number) => {
		const portalsClient = new PortalsClient()
		const response = await portalsClient.GetPortalStream(
			context.portal.id,
			versionNumber,
		)

		const dataUrl = URL.createObjectURL(
			new Blob([response.data], { type: 'text/html' }),
		)

		downloadFile(
			document,
			dataUrl,
			`${context.version.name}-${versionNumber}`,
			'html',
		)
	}, [])

	return (
		<AdministrationPageContainer title={'Portal Versions'} divider={false}>
			<Box display="flex" flexDirection="column" width="100%" height="100%">
				<AdministrationPageTabs
					currentTab={1}
					tabLabels={context.tabLabels}
					onTabChanged={context.onTabChanged}
				/>
				<Divider />
				<Fade in>
					<Box component={Paper} marginTop={2}>
						<Table>
							<TableHead>
								<TableRow>
									<TableCell>Version Number</TableCell>
									<TableCell>Created</TableCell>
									<TableCell>Created By</TableCell>
									<TableCell>Active</TableCell>
									<TableCell>Link</TableCell>
									<TableCell align="right">Actions</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{versions
									.sort((a, b) => b.versionNumber - a.versionNumber)
									.map((version) => (
										<TableRow key={version.id}>
											<TableCell>{version.versionNumber}</TableCell>
											<TableCell>
												{new Date(version.createdDate).toLocaleString()}
											</TableCell>
											<TableCell>
												<UserChip
													assignmentType={AssignmentType.User}
													id={version.createdBy}
												/>
											</TableCell>
											<TableCell>
												<IconButton
													size="small"
													LinkComponent="a"
													href={getLink(version.versionNumber)}
													target="_blank"
												>
													{version.isActive ? (
														<Visibility />
													) : (
														<VisibilityOff color="disabled" />
													)}
												</IconButton>
											</TableCell>
											<TableCell>
												<Box
													// component={TableCell}
													display="flex"
													flexDirection="row"
													gap={1}
													height="100%"
													alignItems="center"
												>
													<Box className={styles.wrapLink}>
														{getLink(version.versionNumber)}
													</Box>
													<ClickToCopyButton
														value={getLink(version.versionNumber)}
														size="small"
													/>
												</Box>
											</TableCell>
											<TableCell align="right">
												<IconButton
													size="small"
													onClick={() => downloadVersion(version.versionNumber)}
												>
													<CloudDownload />
												</IconButton>
											</TableCell>
										</TableRow>
									))}
							</TableBody>
						</Table>
					</Box>
				</Fade>
			</Box>
		</AdministrationPageContainer>
	)
}

const useStyles = makeStyles(() => ({
	wrapLink: {
		overflowWrap: 'anywhere',
	},
}))
